// extracted by mini-css-extract-plugin
export default {"link":"XC-z","disabled":"YC-z"};